import React from 'react';
import { Header, Grid } from 'semantic';
import { useTranslation } from 'react-i18next';
import ThemedSegment from 'components/semantic/Segment';

type Props = {
  label: string;
  numConnectors: number;
  actionComponents: React.ReactNode;
};

export const ChargingGroupPreview: React.FC<Props> = ({
  label,
  numConnectors,
  actionComponents,
}) => {
  const { t } = useTranslation();

  return (
    <ThemedSegment offbackground>
      <Grid columns="equal" verticalAlign="middle">
        <Grid.Row centered verticalAlign="middle">
          <Grid.Column width={6}>
            <Header as="h4" content={label || '-'} style={{ marginTop: 0 }} />
            <p>
              {t(
                'providerAdmin.chargingGroupPreview.numConnectors',
                '{{count}} Connectors',
                {
                  count: numConnectors,
                }
              )}
            </p>
          </Grid.Column>
          <Grid.Column
            floated="right"
            width={2}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
            }}>
            {actionComponents}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ThemedSegment>
  );
};
